<script>
// declare additional options
export default {
  inheritAttrs: false,
  // customOptions: {}
}
</script>

<script setup>

import {ref, computed, onMounted, reactive} from 'vue'
import {useThemeComposable} from 'lxvue3'

const {isMobileDevice, isMobilePhone, userAgent, vertical, denseMode, setDenseMode, setGlobalClick, darkMode, primary, setDarkMode, setPrimary} = useThemeComposable();

const emit = defineEmits(['open-imprint'])

const cookies = reactive({
  allowRequired: true,
  allowPerformance: true
})
const visible = ref(false)

const clearable = computed(() => {
  return props.modelValue && props.isClearable ? true : false
})

onMounted(() => {
  checkCookies()
})

function setCookies(type) {

  switch (type) {
    case 'all':
      cookies.allowRequired = true
      cookies.allowPerformance = true
      break;
    case 'required':
      cookies.allowRequired = true
      cookies.allowPerformance = false
      break;
    case 'selected':
      break;
    default:
  }

  window.localStorage.setItem('tumor-prax_allowed_items', JSON.stringify(cookies))
  visible.value = false
  checkCookies()
}

function checkCookies() {
  const value = JSON.parse(window.localStorage.getItem('tumor-prax_allowed_items'))
  if (!value || (!value.allowRequired && !value.allowPerformance)) {
    visible.value = true
  }
}

function openImprint() {
  emit('open-imprint', {})
}

import imgPath from '../../assets/litixsoft_logo_blau_orange.png'

</script>

<template>
  <div v-if="visible" class="absolute top-0 left-0 bottom-0 right-0 bg-slate-900/70 flex flex-col overflow-hidden" style="backdrop-filter: blur(9px);z-index:900;">

    <div :class="[isMobileDevice ? (isMobilePhone ? 'absolute top-2 left-2 bottom-2 right-2':'absolute top-12 left-12 bottom-12 right-12') : 'my-auto mx-auto max-w-[650px] max-h-[850px] basis-full']"
         class="bg-white p-5 pb-3 rounded-sm shadow-xl flex flex-col overflow-hidden">

      <img :src="imgPath" style="width:100px;margin-left: auto;"/>
      <lx-divider class="my-3"></lx-divider>
      <div class="basis-full overflow-y-auto">
        <h4 class="font-bold">Einwilligung zu Cookies und Datennutzung</h4>
        <p class="mt-3 text-sm">Wir und unsere Partner setzen auf unserer Website Cookies ein und erfragen Informationen von Ihrem Browser. Einige von ihnen sind notwendig, während andere nicht notwendig sind, uns jedoch helfen, die Navigation auf der Website zu verbessern, die Nutzung der Website
          zu analysieren oder unsere Marketingaktivitäten zu unterstützen. Sie können in den Einsatz der nicht notwendigen Cookies mit dem Klick auf die Schaltfläche “Alle verwenden” einwilligen oder per Klick auf die Schaltfläche „Notwendige verwenden“ ablehnen sowie nur bestimmte Cookie-Gruppen
          (Performance, Präferenzen, Statistiken, Marketing, ...) auswählen und mit der Schaltfläche “Auswahl verwenden” akzeptieren. Sie können alle diese Einstellungen jederzeit aufrufen und Cookies auch nachträglich jederzeit abwählen. Gehen Sie dazu bitte auf unsere <span
            class="text-sky-500 hover:underline cursor-pointer" @click="openImprint">Datenschutzerklärung</span>, die weitere Informationen enthält und jeweils im Fußbereich unserer Website zu finden ist.</p>
        <div class="bg-slate-100 rounded-sm p-4 text-sm mt-3 flex flex-row">
          <div class="basis-full">
            <h5 class="font-bold text-md">Notwendige</h5>
            <p class="text-sm">Alle Cookies und Session-Einträge, die für den Betrieb der Seite benötigt werden. Ohne diese kann die Seite nicht ausgeführt werden. Dazu zählen auch die Einträge, welche Ihre Auswahl speichern.</p>
            <ul style="list-style-type: disc;padding-left:20px;margin-top:10px;">
              <li>Gespeicherte Auswahl der Cookieabfrage, solange diese nicht abgelehnt wurde</li>
            </ul>
          </div>
          <lx-divider vertical class="mx-3"></lx-divider>
          <div class="flex flex-col">
            <div class="my-auto">
              <lx-switch name="allowRequired" v-model="cookies.allowRequired"></lx-switch>
            </div>
          </div>
        </div>
<!--        <div class="bg-slate-100 rounded-sm p-4 text-sm mt-3 flex flex-row">-->
<!--          <div class="basis-full">-->
<!--            <h5 class="font-bold text-ms">Funktionale</h5>-->
<!--            <p class="text-sm">Alle Cookies und Session-Einträge, die für den Betrieb der Seite benötigt werden. Ohne diese kann die Seite nicht ausgeführt werden. Dazu zählen auch die Einträge, welche Ihre Auswahl speichern.</p>-->
<!--            <ul style="list-style-type: disc;padding-left:20px;margin-top:10px;">-->
<!--              <li>Gespeicherte Auswahl der Cookieabfrage, solange diese nicht abgelehnt wurde</li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <lx-divider vertical class="mx-3"></lx-divider>-->
<!--          <div class="flex flex-col">-->
<!--            <div class="my-auto">-->
<!--              <lx-switch name="allowPerformance" v-model="cookies.allowPerformance"></lx-switch>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <template v-if="!cookies.allowPerformance && !cookies.allowRequired">
        <lx-divider class="my-3"></lx-divider>
        <lx-alert class="mb-2 text-sm" type="error" text="Achtung: Sie haben die notwendigen Cookies deaktiviert. Somit können wir weder Ihre Entscheidung speichern noch einen reibungslosen Betrieb der Seite garantieren. Sie werden daher diese Cookieabfrage dauerhaft sehen."></lx-alert>
      </template>
      <lx-divider class="my-3"></lx-divider>
      <div class="flex flex-col md:flex-row">
        <div class="basis-full p-1">
          <lx-btn label="Alle verwenden" data-cy-1="useAllCookiesBtn" @click="setCookies('all')" block></lx-btn>
        </div>
        <div class="basis-full p-1">
          <lx-btn label="Notwendige verwenden" data-cy-1="useNecessaryCookiesBtn" @click="setCookies('required')"  block></lx-btn>
        </div>
        <div class="basis-full p-1">
          <lx-btn :disabled="!cookies.allowPerformance && !cookies.allowRequired" label="Auswahl verwenden" data-cy-1="useSelectionBtn" @click="setCookies('selected')" block></lx-btn>
        </div>
      </div>
      <lx-divider class="my-3"></lx-divider>
      <div class="flex flex-row">
        <div class="mx-auto text-xs text-sky-500 hover:underline cursor-pointer" @click="openImprint">Impressum + Datenschutz</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
